module.exports = __webpack_public_path__ + "img/logo.ff283ae2.png";